const pasarela = {
  readPasarelas: 'pasarelas-pago',
  readPasarelasConfiguracion: 'pasarela-pago/{{uuid_pasarela_pago}}/configurar/{{uuid_academia}}',
  readPasarelasParametros: 'pasarela-pago/{{uuid_pasarela_pago}}/campos-parametros/{{uuid_academia}}'
}

export default pasarela
